/**
 * enum with possible salutations of users
 */
export enum NutzerAnrede {
    Male = 'Herr',
    Female = 'Frau',
    Neutral = 'Divers',
}
